import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { usePrefs } from 'wsm-common-data';

import vehiclePropType from '../../../../propTypes/vehiclePropType';
import { hasInTransitBadge } from '../../../../utilities/hasInTransitBadge';
import PricingElement from '../PricingElement';
import HighlightedAttributeContainer from '../HighlightedAttributeContainer';
import WebIntegrationPlaceholder from '../../../WebIntegrationPlaceholder';
import VehicleCardTabs from '../VehicleCardTabs';
import Callout from '../../Callout';
import LocationContainer from '../LocationContainer';
import CTAButtons from '../CTAButtons';
import WebIntegrationVehiclePricingPlaceholder from '../WebIntegrationVehiclePricingPlaceholder';
import DetailedIncentivesContainer from '../DetailedIncentivesContainer';

const GridView = ({
	accountId,
	accountInfo,
	highlightedAttributes,
	isDisplayingEPrice,
	incentives,
	setIsDisplayingEPrice,
	showExpandedPricing,
	showNewCarBoostPaymentsInDetails,
	setShowExpandedPricing,
	tabArray,
	tabLabels,
	vehicle
}) => {
	const { callout: callouts, classification, uuid, type } = vehicle;
	const { layout } = useSelector((state) => state.layout);
	const { showInformationTabs, showIncentiveLinkOnGrid } = usePrefs();

	return (
		<div className="h-100 d-flex flex-column">
			{!showInformationTabs?.toLowerCase().includes('pricing') && (
				<PricingElement
					accountId={accountId}
					accountInfo={accountInfo}
					incentives={incentives}
					isDisplayingEPrice={isDisplayingEPrice}
					setShowExpandedPricing={setShowExpandedPricing}
					showExpandedPricing={showExpandedPricing}
					showNewCarBoostPaymentsInDetails={
						showNewCarBoostPaymentsInDetails
					}
					vehicle={vehicle}
				/>
			)}
			<HighlightedAttributeContainer
				accountInfo={accountInfo}
				hasInTransitBadge={hasInTransitBadge(callouts)}
				highlightedAttributes={highlightedAttributes}
				isNewCarBoost={!!vehicle.isNewCarBoost}
				isSpotlightedVehicle={!!vehicle.spotlightedVehicle}
				vehicleClassification={classification}
				/* TODO: `vehicle.type` will always be a string once all sites are on WIS */
				vehicleType={type === 'new' || type === 2 ? 'new' : 'used'}
			/>
			{showNewCarBoostPaymentsInDetails && (
				<WebIntegrationPlaceholder
					location="vehicle-payments-primary"
					classNames={['float-left', 'ddc-font-size-xsmall']}
					isNewCarBoost={showNewCarBoostPaymentsInDetails}
				/>
			)}
			{showInformationTabs && (
				<VehicleCardTabs
					id={uuid}
					tabArray={tabArray}
					tabLabels={tabLabels}
				/>
			)}
			{showIncentiveLinkOnGrid === 'true' && layout === 'grid' && (
				<DetailedIncentivesContainer
					accountInfo={accountInfo}
					incentives={incentives}
					vehicle={vehicle}
					isSRPGridLayout={layout === 'grid'}
				/>
			)}
			<Callout callouts={callouts} vehicle={vehicle} />
			<LocationContainer vehicle={vehicle} />
			<div className="d-flex flex-column justify-content-end flex-grow-1">
				<div className="vehicle-ctas">
					<CTAButtons
						accountId={accountId}
						vehicle={vehicle}
						isDisplayingEPrice={isDisplayingEPrice}
						setIsDisplayingEPrice={setIsDisplayingEPrice}
					/>
				</div>
				<WebIntegrationVehiclePricingPlaceholder vehicle={vehicle} />
			</div>
		</div>
	);
};

GridView.propTypes = {
	accountId: PropTypes.string.isRequired,
	accountInfo: PropTypes.shape({}),
	highlightedAttributes: PropTypes.arrayOf(PropTypes.shape({})),
	incentives: PropTypes.shape({}),
	isDisplayingEPrice: PropTypes.bool.isRequired,
	setIsDisplayingEPrice: PropTypes.func.isRequired,
	setShowExpandedPricing: PropTypes.func.isRequired,
	showExpandedPricing: PropTypes.bool.isRequired,
	showNewCarBoostPaymentsInDetails: PropTypes.bool,
	tabArray: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	tabLabels: PropTypes.shape({
		info: PropTypes.string,
		pricing: PropTypes.string,
		specials: PropTypes.string
	}),
	vehicle: vehiclePropType.isRequired
};
export default GridView;
